import { Injectable } from '@angular/core';
import { AuthenticatedApiService } from './authenticated-api.service';
import { PaymentMethodBuilder } from '../builders/payment-method-builder';
import { CardResponse } from '../model/payment-method';
import * as i0 from "@angular/core";
import * as i1 from "./authenticated-api.service";
export class PaymentMethodApiService {
    constructor(api) {
        this.api = api;
    }
    listPaymentMethods(companyId) {
        return this.api.get('/user/paymethods', { company_id: companyId }).toPromise().then(response => {
            return response.paymethods.map(data => PaymentMethodBuilder.buildPaymentMethod(data));
        });
    }
    getPaymentMethod(id) {
        return this.api.get(`/user/paymethod/${id}`).toPromise().then(response => {
            return PaymentMethodBuilder.buildPaymentMethod(response.paymethod);
        });
    }
    checkCard(id) {
        return this.api.get(`/paymethod/checkcard/${id}`).toPromise().then(response => {
            const cardResponse = new CardResponse();
            cardResponse.paymethod = PaymentMethodBuilder.buildPaymentMethod(response.paymethod);
            if (response.challenge) {
                cardResponse.challenge = response.challenge;
            }
            return cardResponse;
        });
    }
    cancelReservationPayment(id) {
        return this.api.put(`/reservation/cancel_reservation_payment/${id}`).toPromise().then(response => {
            return response;
        });
    }
    updatePaymentMethod(paymentMethod) {
        let payload = {
            alias: paymentMethod.alias,
            cost_center: paymentMethod.costCenterId
        };
        return this.api.put(`/user/paymethod/${paymentMethod.id}`, JSON.stringify(payload))
            .toPromise().then(response => PaymentMethodBuilder.buildPaymentMethod(response.paymethod));
    }
    checkifCanDeletePaymethod(paymethodID) {
        return this.api.get(`/user/check_reservations_with_paymethod/${paymethodID}`)
            .toPromise().then(response => (response.warning && response.warning != 'false'));
    }
}
PaymentMethodApiService.ɵfac = function PaymentMethodApiService_Factory(t) { return new (t || PaymentMethodApiService)(i0.ɵɵinject(i1.AuthenticatedApiService)); };
PaymentMethodApiService.ɵprov = i0.ɵɵdefineInjectable({ token: PaymentMethodApiService, factory: PaymentMethodApiService.ɵfac });
(function () { i0.ɵsetClassMetadata(PaymentMethodApiService, [{
        type: Injectable
    }], function () { return [{ type: i1.AuthenticatedApiService }]; }, null); })();
//# sourceMappingURL=payment-methods-api.service.js.map